const ErrorTypes = {};
const Events = {};
function defineErrorTypes(errorTypes) {
  Object.assign(ErrorTypes, errorTypes);
}
function defineEventTypes(eventTypes) {
  Object.assign(Events, eventTypes);
}
export { defineErrorTypes, defineEventTypes, ErrorTypes, Events };